import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

import { colors } from 'common';

interface DialogCloseButtonProps {
  onClose: () => void;
}

export function DialogCloseButton(props: DialogCloseButtonProps) {
  const { onClose } = props;
  return (
    <IconButton
      aria-label="Close"
      onClick={() => onClose()}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: colors.content.default,
      }}
    >
      <CloseIcon />
    </IconButton>
  );
}
